<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.package") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t('ui.status') }}
                  b-form-select(v-model="packageStatus" :disabled="loading" size="sm")
                    option(value="") {{ $t('ui.all') }}
                    option(value="ACTIVE") {{ $t('ui.active') }}
                    option(value="INACTIVE") {{ $t('ui.inactive') }}

              .form-group.col-6.mb-1(v-if="isAdmin")
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getPackageList()"
                  variant="primary"
                  size="sm"
                )
              //- .form-group.col-12(v-if="isAdmin && isEditAccess")
              //-   b-button(v-b-modal.addPackage type="button" variant="info" size="sm")
              //-     i.fa.fa-plus
              //-     span.ml-1 {{ $t("ui.combine.add_package") }}
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="6%")
                          span(:title="$t('ui.package_id')") {{ $t('ui.package_id') }}
                        th(width="18%")
                          span(:title="$t('ui.name')") {{ $t('ui.name') }}
                        th(width="8%")
                          span(:title="$t('ui.type')") {{ $t('ui.type') }}
                        th(width="6%")
                          span(:title="$t('ui.price')") {{ $t('ui.price') }}
                        th(width="13%")
                          span(:title="$t('ui.bo_right')") {{ $t('ui.bo_right') }}
                        th(width="5%")
                          span(:title="$t('ui.sequence')") {{ $t('ui.sequence') }}
                        th(width="7%")
                          span(:title="$t('ui.package_level')") {{ $t('ui.package_level') }}
                        //- th.text-center(width="5%")
                        //-   span(:title="$t('ui.status')") {{ $t('ui.status') }}
                        th(width="10%")
                          span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                        th.text-center(width="5%" v-if="isAdmin && isEditAccess")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="packageList.length == 0")
                        td(colspan="11").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in packageList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.package_id") {{ item.package_id }}
                        td
                          //- span(:title="item.package_desc_en") {{ item.package_desc_en }}
                          b-button.btn-collapse.text-decoration-none(size="sm" block v-b-toggle="'collapse-' + item.package_id" variant="link" style="text-transform:none;")
                            .d-flex.align-items-center.justify-content-start.font-weight-normal(style="color: #6c757d;")
                              i.fa.fa-chevron-down.mr-2(aria-hidden="true")
                              .text-left {{ item.package_desc_en }}
                          b-collapse(
                            :id="'collapse-' + item.package_id"
                            accordion="accordion-account"
                            )
                            .clusterize-scroll.table-responsive.px-2.pt-2
                              table.table.table-sm.table-bordered.table-striped.table-hover
                                tbody.clusterize-content
                                  tr
                                    td
                                      span {{ $t("ui.english") }}
                                    td.text-right
                                      span {{ item.package_desc_en }}
                                  tr
                                    td
                                      span {{ $t("ui.simplified_chinese") }}
                                    td.text-right
                                      span {{ item.package_desc_cn }}
                                  tr
                                    td
                                      span {{ $t("ui.traditional_chinese") }}
                                    td.text-right
                                      span {{ item.package_desc_tw }}
                                  tr
                                    td
                                      span {{ $t("ui.philippine") }}
                                    td.text-right
                                      span {{ item.package_desc_ph }}
                                  tr
                                    td
                                      span {{ $t("ui.thai") }}
                                    td.text-right
                                      span {{ item.package_desc_th }}
                                  tr
                                    td
                                      span {{ $t("ui.vietnamese") }}
                                    td.text-right
                                      span {{ item.package_desc_vi }}
                                  tr
                                    td
                                      span {{ $t("ui.indonesian") }}
                                    td.text-right
                                      span {{ item.package_desc_id }}
                                  tr
                                    td
                                      span {{ $t("ui.myanmar") }}
                                    td.text-right
                                      span {{ item.package_desc_my }}
                                  tr
                                    td
                                      span {{ $t("ui.japanese") }}
                                    td.text-right
                                      span {{ item.package_desc_jp }}
                                  tr
                                    td
                                      span {{ $t("ui.korean") }}
                                    td.text-right
                                      span {{ item.package_desc_kr }}
                        td
                          span(:title="item.package_type") {{ item.package_type }}
                        td
                          //- span(:title="item.package_price") {{ item.package_price }}
                          span(:title="$n(item.package_price, 'currency')") {{ $n(item.package_price, 'currency') }}
                        td
                          span(v-if="item.bo_right == 1" :title='$t("ui.full_back_office_access_right")') {{ $t("ui.full_back_office_access_right") }}
                          span(v-else :title='$t("ui.read_only_back_office")') {{ $t("ui.read_only_back_office") }}
                        td
                          span(:title="item.sequence") {{ item.sequence }}
                        td
                          span(:title="item.package_level") {{ item.package_level }}
                        //- td.text-center
                        //-   span(:title="$t('ui.' + item.status.toLowerCase())" :class="$helpers.badgeClass(item.status)") {{ $t("ui." + item.status.toLowerCase()) }}
                        td
                          span(:title="item.remark") {{ item.remark }}
                        td.actions.text-center.align-middle(v-if="isAdmin && isEditAccess")
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                              href="javascript:void(0)"
                              @click="onEdit(item)"
                              :title="$t('ui.edit')"
                              )
                          //- span
                          //-   a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                          //-     href="javascript:void(0)"
                          //-     @click="onDelete(item)"
                          //-     :title="$t('ui.delete')"
                          //-     )

      //- addpackage(@clicked="addPackage" @failed="handleFailed")
      editpackage(ref="editpackage" :item="editSelectedPackage" @clicked="afterEdit" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
// import addpackage from "@/components/content/package/addPackage.vue";
import editpackage from "@/components/content/package/editPackage.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    // addpackage,
    editpackage
  },
  data: () => ({
    loading: false,
    packageStatus: "",
    packageList: [],
    editSelectedPackage: null,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_package");
    }
  },
  mounted: function() {
    this.getPackageList();
  },
  methods: {
    onEdit(e) {
      this.editSelectedPackage = e;
      this.$refs.editpackage.$refs.editPackage.show();
    },
    afterEdit() {
      this.getPackageList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_package"), this.$t("message.success"), "success");
    },
    // onDelete:function(e) {
    //   this.$helpers
    //     .alert({
    //       title: this.$t("ui.delete"),
    //       text: this.$t("message.delete_package_confirm", { package: e.package_id + ' - ' + e.package_type }),
    //       type: "question",
    //       showCancelButton: true
    //     })
    //     .then(result => {
    //       if (result.value) {
    //         this.confirmDelete(e);
    //       }
    //     });
    // },
    // confirmDelete: function(e) {
    //   let url = config.deletePackageUrl();

    //   var json = {
    //     auth_token: this.$store.getters.sessionToken,
    //     action_by: this.$store.getters.loginId,
    //     package_id: e.package_id
    //   };

    //   this.feedback.success = true;
    //   this.loading = true;
    //   this.$http.post(url, json).then(
    //     function(response) {
    //       this.loading = false;
    //       // Success
    //       try {
    //         if (response) {
    //           if (typeof response.data.status == "string") {
    //             this.feedback.success = response.data.status == "1";
    //           } else {
    //             this.feedback.success = response.data.status == 1;
    //           }
    //           this.feedback.status = response.data.statusdesc;
    //           if (this.feedback.success == true) {
    //             // item.status = status;
    //             this.getPackageList();
    //             this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
    //           } else {
    //             if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //           }
    //         }
    //       } catch (error) {
    //         this.feedback.success = false;
    //         this.feedback.status = errorTags.request.failed;
    //         this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //       }
    //     },
    //     function(response) {
    //       this.loading = false;
    //       // Error
    //       this.feedback.success = false;
    //       this.feedback.status = errorTags.request.failed;
    //       this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //     }
    //   );
    // },
    getPackageList: function() {
      let url = config.getPackageListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        package_status: this.packageStatus
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.packageList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },

    // addPackage: function(account_type) {
    //   // this.searchType = account_type;
    //   // this.searchID = "";
    //   this.getPackageList();

    //   this.$helpers.showDialog(this.$t("ui.combine.add_package"), this.$t("message.success"), "success");
    // },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>